'use client';

import DollarCoinSvg from '@/assets/svgs/dollar-coin.svg';
import InputContainer from '@/shared/components/FormInputs/InputContainer/InputContainer';
import classNames from 'classnames';
import { HTMLAttributes } from 'react';

interface CurrencyInputProps
  extends Omit<HTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  step?: string | number;
  min?: string | number;
  max?: string | number;
  placeholder?: string;
  inputClassName?: string;
  containerClassName?: string;
  labelClassName?: string;
}

const CurrencyInput = ({
  label,
  value,
  onChange,
  error,
  helperText,
  required = false,
  disabled = false,
  step = '0.01',
  min,
  max,
  placeholder = '0.00',
  inputClassName,
  containerClassName,
  labelClassName,
  ...inputProps
}: CurrencyInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <InputContainer
      label={label}
      className={containerClassName}
      labelClassName={labelClassName}
      error={error}
      helperText={helperText}
      isTouched={!!error}>
      <label
        className={classNames('input input-bordered', {
          'input-error': !!error,
        })}>
        <DollarCoinSvg className="h-5 w-5 text-gray-500" />
        <input
          type="number"
          value={value}
          onChange={handleChange}
          step={step}
          min={min}
          max={max}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={classNames(
            {
              'cursor-not-allowed bg-gray-50': disabled,
            },
            inputClassName
          )}
          {...inputProps}
        />
      </label>
    </InputContainer>
  );
};

export default CurrencyInput;
